import { jsx, jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { DropdownMenu } from "../dropdown-menu/dropdown-menu.es.js";
import { DropdownMenuButton } from "../dropdown-menu/dropdown-menu-button.es.js";
import "../dropdown-menu/dropdown-menu-item.es.js";
import "../dropdown-menu/dropdown-menu-link.es.js";
import { DropdownMenuList } from "../dropdown-menu/dropdown-menu-list.es.js";
import "../dropdown-menu/dropdown-menu-section.es.js";
import "react";
import "../dropdown-menu/dropdown-menu-context.es.js";
import "../dropdown-menu/dropdown-menu-separator.styles.es.js";
import "../dropdown-menu/dropdown-menu-text.es.js";
import { UtilityButton } from "../utility-button/utility-button.es.js";
import { TabMenuWrapper } from "./tab-menu.styles.es.js";
const propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired
};
const defaultProps = {
  as: void 0
};
const TabMenu = ({ as, children, ...restProps }) => /* @__PURE__ */ jsx(TabMenuWrapper, { children: /* @__PURE__ */ jsxs(DropdownMenu, { align: "right", children: [
  /* @__PURE__ */ jsx(
    DropdownMenuButton,
    {
      as: UtilityButton,
      forwardedAs: as,
      icon: "ellipsis",
      magnitude: "small",
      tabIndex: "-1",
      ...restProps
    }
  ),
  /* @__PURE__ */ jsx(DropdownMenuList, { children })
] }) });
TabMenu.propTypes = propTypes;
TabMenu.defaultProps = defaultProps;
export {
  TabMenu
};
